// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Contactos from './contactos/reducers';
import Mantenimientos from './mantenimientos/reducers';
import Invoices from './invoices/reducers';
import Estimates from './estimates/reducers';
import Productos from './productos/reducers';
import Contratos from './contratos/reducers';
import Layout from './layout/reducers';
import Clientes from './clients/reducers'
import Oficinas from './oficinas/reducers'
import Usuarios from './users/reducers'
import Staff from './staff/reducers'
import StaffProfiles from './staff-profiles/reducers'
import Erights from './erights/reducers'
import Logs from './logs/reducers'
import Configuration from './configuration/reducers'
import Languages from './languages/reducers'
import Incidencias from './incidencias/reducers'
import Tipos from './tipo-incidencias/reducers'
import Prioridades from './prioridad-incidencias/reducers'
import Images from './images/reducers'
import Roles from './roles/reducers'
import PrintConf from './print-conf/reducers'
import PrivacyPolicy from './privacy-policy/reducers'
import FormulariosInternos from './formularios-internos/reducers'
import Noticias from './noticias/reducers'
import TiposNoticia from './tipos-noticia/reducers'
import Secciones from './secciones/reducers'
import UneTypes from './une-types/reducers'
import Servicios from './servicios/reducers'
import Eventos from './eventos/reducers'
import Redes from './redes/reducers'
import Documentos from './documentos/reducers'
import Categorias from './categorias/reducers'
import Certificaciones from './certificaciones/reducers'
import PuntosInteres from './puntos-interes/reducers'
import CategoriasPOI from './categoriasPOI/reducers'
import Enlaces from './enlaces/reducers'
import Demandas from './demandas/reducers'
import CategoriasEnlaces from './categorias-enlaces/reducers'
import Medios from './medios/reducers'
import ConfRegistro from './confRegistro/reducers'
import TiposVisitante from './tipos-visitante/reducers'
import TiposSolicitante from './tipos-solicitante/reducers'
import RangosEdad from './rangos-edad/reducers';
import Procedencias from './procedencias/reducers'
import Registros from './registros/reducers'
import Destinos from './destinos/reducers';
import ItSendStats from './infotools-send-stats/reducers';
import EstadisticasInfotools from './estadisticas-infotools/reducers';
import Chat from './chat/reducers';
import Survey from './survey/reducers';
import PeriodSurvey from './period-survey/reducers';
import MediaSurvey from './media-survey/reducers';
import QuestionSurvey from './question-survey/reducers';
import QuestionType from './question-type/reducers';
import OptionAnswer from './option-answer/reducers';
import InstanceSurvey from './instance-survey/reducers';
import ConfSurvey from './confSurvey/reducers';
import Dashboard from './dashboard/reducers';
import FavOrigins from './favOrigins/reducers';
import QRConf from './qr-conf/reducers';
import Rutas from './rutas/reducers'
import CategoriasRuta from './categorias-ruta/reducers'
import Travels from './travels/reducers';
import CategoriesTravel from './category-travel/reducers';
import EventsContacts from './events-contacts/reducers';
import GroupsContacts from './groups-contacts/reducers';
import TypesContacts from './types-contacts/reducers';
import OtherDataContacts from './other-data-contacts/reducers';
import Activities from './activities/reducers';
import Persons from './persons/reducers'
import Contacts from './contacts/reducers'
import CategoryExperiences from './category-experiences/reducers';
import Experiences from './experiences/reducers';
import Accommodations from './accommodations/reducers';
import ConfOpinometro from './confOpinometro/reducers';
import InstanceOpinometro from './instance-opinometro/reducers';
import Opinometro from './opinometro/reducers';
import OptionAnswersOpinometro from './option-answer-opinometro/reducers';
import QuestionOpinometro from './question-opinometro/reducers';
import QuestionTypesOpinometro from './question-type-opinometro/reducers';
import Devices from './devices/reducers';
import DevicesGroups from './devices-groups/reducers';
import StructureItems from './structure-items/reducers';
import TranslationAI from './translation-ai/reducers';
import Writesonic from './writesonic/reducers'
import InstancesInternalForms from './instances-internal-forms/reducers';
import SeaConfig from './sea-config/reducers';
import SeaFlags from './sea-flags/reducers';
import SeaLogs from './sea-logs/reducers';
import ConfigInfotools from './config-infotools/reducers';
import ModulesInfotools from './modules-infotools/reducers';
import UsersInfotools from './users-infotools/reducers';

export default (combineReducers({
    Auth,
    Contactos,
    Mantenimientos,
    Invoices,
    Estimates,
    Productos,
    Contratos,
    Layout,
    Clientes,
    Oficinas,
    Usuarios,
    Staff,
    StaffProfiles,
    Erights,
    Logs,
    Configuration,
    Languages,
    Incidencias,
    Tipos,
    Prioridades,
    Images,
    Roles,
    PrintConf,
    PrivacyPolicy,
    FormulariosInternos,
    Noticias,
    TiposNoticia,
    Secciones,
    UneTypes,
    Servicios,
    Eventos,
    Redes,
    Documentos,
    Categorias,
    Certificaciones,
    PuntosInteres,
    CategoriasPOI,
    Enlaces,
    Demandas,
    CategoriasEnlaces,
    Medios,
    ConfRegistro,
    TiposVisitante,
    TiposSolicitante,
    RangosEdad,
    Procedencias,
    Registros,
    Destinos,
    ItSendStats,
    EstadisticasInfotools,
    Chat,
    Survey,
    PeriodSurvey,
    MediaSurvey,
    QuestionSurvey,
    QuestionType,
    OptionAnswer,
    InstanceSurvey,
    ConfSurvey,
    Dashboard,
    FavOrigins,
    QRConf,
    Rutas,
    CategoriasRuta,
    Travels,
    CategoriesTravel,
    EventsContacts,
    GroupsContacts,
    TypesContacts,
    OtherDataContacts,
    Activities,
    Persons,
    Contacts,
    CategoryExperiences,
    Experiences,
    Accommodations,
    Devices,
    DevicesGroups,
    ConfOpinometro,
    InstanceOpinometro,
    Opinometro,
    OptionAnswersOpinometro,
    QuestionOpinometro,
    QuestionTypesOpinometro,
    StructureItems,
    TranslationAI,
    Writesonic,
    InstancesInternalForms,
    SeaConfig,
    SeaFlags,
    SeaLogs,
    ConfigInfotools,
    ModulesInfotools,
    UsersInfotools
}): any);
